import { onMounted } from "vue";
import { useFiltersStore } from "@/store";
import { FilterDefinition, FilterType, FilterTypeEnum } from "@/features/filters";

export const useFilterInitializer = (recipe: Array<FilterDefinition>, filterType: FilterType, zonePrefix?: string) => {
  const filtersStore = useFiltersStore();
  const { applyPanelSelectedFilters, applyFilters, panelSelectedFilters, filtersApplied } = filtersStore;

  const applyDefaults = () => {
    let setStoreWithEmpty = true;

    recipe.forEach((filter: FilterDefinition) => {
      const defaultValue = filter.value;
      if (defaultValue === undefined || defaultValue === null) return;

      const { key: filterKey, label: filterLabel, sectionLabel, groupId, groupLabel } = filter;

      const fullKey = zonePrefix ? `${zonePrefix}.${filterKey}` : filterKey;
      const [zone, key] = fullKey.includes(".") ? fullKey.split(".") : ["default", fullKey];

      const zonePanel = panelSelectedFilters[zone] || {};
      const zoneApplied = filtersApplied[zone] || {};

      if (filterType === FilterTypeEnum.PANEL_FILTERS && zonePanel[key]) return;
      if (filterType !== FilterTypeEnum.PANEL_FILTERS && zoneApplied[key]) return;

      const filterData = {
        ...defaultValue,
        ...(groupId ? { groupId } : {}),
        ...(groupLabel ? { groupLabel } : {}),
        ...(sectionLabel ? { sectionLabel } : {}),
        ...(filterLabel ? { filterLabel } : {}),
        filterType,
        filterKey
      };

      if (filterType === FilterTypeEnum.PANEL_FILTERS) {
        applyPanelSelectedFilters(zone, key, filterData);
        applyFilters(zone, key, filterData);
      } else {
        applyFilters(zone, key, filterData);
      }
      setStoreWithEmpty = false;
    });

    if (setStoreWithEmpty && zonePrefix) {
      panelSelectedFilters[zonePrefix] = {};
      filtersApplied[zonePrefix] = {};
    }
  };

  onMounted(() => {
    applyDefaults();
  });
};
